import classNames from 'classnames';
import React, {
  cloneElement,
  FC,
  ReactElement,
  JSXElementConstructor,
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { IntersectionOptions, useInView } from 'react-intersection-observer';
import { twMerge } from 'tailwind-merge';

type ViewProps = Partial<any> & {
  viewOptions?: IntersectionOptions;
  placeholder: ReactElement<any, string | JSXElementConstructor<any>>;
  initialLoad?: boolean;
  dataTestId?: string;
};

const ImageLazy: FC<ViewProps> = React.forwardRef(
  ({ initialLoad = false, viewOptions = {}, src, placeholder, className, dataTestId, ...rest }) => {
    const { inView, ref } = useInView({
      threshold: 0.05,
      ...viewOptions
    });
    const viewRef = useRef<boolean>(false);

    const [complete, setComplete] = useState<boolean>(initialLoad);
    const [loaded, setLoaded] = useState<boolean>(initialLoad);

    const handleComplate = useCallback(() => {
      setComplete(true);
    }, []);

    useEffect(() => {
      let img;
      if (viewRef.current) return;
      if (inView) {
        viewRef.current = true;
        setLoaded(true);
        img = new Image();
        img.src = src;
        img.onload = handleComplate;
        img.onerror = handleComplate;
      }
      return () => {
        img = null;
      };
    }, [inView]);

    return (
      <>
        {!complete && cloneElement(placeholder, { ref })}
        <img
          data-testid={dataTestId}
          {...rest}
          className={twMerge(
            classNames(className, {
              hidden: !complete
            })
          )}
          src={loaded ? src : ''}
          alt={rest?.alt || 'Weee! - Groceries Delivered'}
        />
      </>
    );
  }
);

export default ImageLazy;
